import React from 'react';
import { FieldComponent } from '../../../types/FieldComponent';
import { BooleanFilter } from '../filters/BooleanFilter';
import { Stack } from '@mui/material';
import Link from '@mui/material/Link';

export const SPLinkField: FieldComponent<boolean> = ({
  onChange,
  disabled,
  defaultValue,
  columnSchema,
  column,
}) => {
  return (
    <>
      <Stack
        direction={'column'}
        sx={{
          padding: '10px',
          width: '100%',
          minHeight: '43px',
          border: '1px solid #ccc',
          background: '#fff',
        }}
      >
        {defaultValue?.map((item: any) => {
          return (
            <Link
              href={`${columnSchema.client.urlPath}/${item?.id}`}
              target={'_blank'}
            >
              {item?.name}
            </Link>
          );
        })}
      </Stack>
    </>
  );
};

SPLinkField.includes = (query = undefined, value = undefined) => {
  if (query === undefined || value === undefined || value === null) return true;
  const valueString = value.toString();
  //console.log(query,valueString);
  return query.some((queryPart: string) => {
    valueString.includes(queryPart);
  });
};

SPLinkField.comparator = (one = false, other = false) => {
  if (one === other) return 0;
  if (one && !other) return -1;
  return 1;
};

SPLinkField.FilterRenderer = BooleanFilter;
